import axios from 'axios';

/**
 * Dashboard için API servis katmanı
 */
class DashboardService {
  /**
   * Dashboard istatistiklerini getir
   * @param {string} appToken - Uygulama tokeni
   * @param {string} userId - Kullanıcı ID
   * @returns {Promise<object>} Dashboard istatistikleri
   */
  async fetchDashboardStats(appToken, userId) {
    try {
      const response = await axios.get("https://app.hhoms.com/api/form/Dashboard", {
        headers: {
          ApplicationToken: appToken,
          User: userId,
        },
      });

      const dashboardData = response.data.dashboard || {};
      
      return {
        totalForms: dashboardData.allForm || 0,
        activeForms: dashboardData.activeForm || 0,
        recordForms: dashboardData.recordForm || 0,
        archiveForms: dashboardData.archiveForm || 0
      };
    } catch (error) {
      console.error('Dashboard istatistikleri alınırken hata oluştu:', error);
      throw new Error('Dashboard verileri yüklenemedi');
    }
  }

  /**
   * Form listesini getir (eğer gerekli ise)
   * @param {string} appToken - Uygulama tokeni
   * @param {string} userId - Kullanıcı ID
   * @returns {Promise<Array>} Form listesi
   */
  async fetchFormList(appToken, userId) {
    try {
      // Bu endpoint'i gerçek API'nize göre düzenleyin
      const response = await axios.get("https://app.hhoms.com/api/form/list", {
        headers: {
          ApplicationToken: appToken,
          User: userId,
        },
      });

      return response.data.forms || [];
    } catch (error) {
      console.error('Form listesi alınırken hata oluştu:', error);
      throw new Error('Form listesi yüklenemedi');
    }
  }
}

export default new DashboardService();
